import AssignmentSchedules from './AssignmentSchedules';

export default AssignmentSchedules;
